// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","copyright":"Footer_copyright__JQMtz","logo":"Footer_logo__+JiYo","white":"Footer_white__uqXA0","header":"Footer_header__dnSM4"};